/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './speciality-vitals.reducer';

export const SpecialityVitalsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const specialityVitalsEntity = useAppSelector(state => state.specialityVitals.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="specialityVitalsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.specialityVitals.detail.title">SpecialityVitals</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.id">Id</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.active">Active</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.cursor}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.title">Title</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.title}</dd>
          <dt>
            <span id="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.unitsOfMeasure">Units Of Measure</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.unitsOfMeasure}</dd>
          <dt>
            <span id="valueType">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.valueType">Value Type</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.valueType}</dd>
          <dt>
            <span id="normalRangeLowerLimit">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.normalRangeLowerLimit">Normal Range Lower Limit</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.normalRangeLowerLimit}</dd>
          <dt>
            <span id="normalRangeUpperLimit">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.normalRangeUpperLimit">Normal Range Upper Limit</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.normalRangeUpperLimit}</dd>
          <dt>
            <span id="possibleRangeLowerLimit">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.possibleRangeLowerLimit">Possible Range Lower Limit</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.possibleRangeLowerLimit}</dd>
          <dt>
            <span id="possibleRangeUpperLimit">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.possibleRangeUpperLimit">Possible Range Upper Limit</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.possibleRangeUpperLimit}</dd>
          <dt>
            <span id="symptom">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.symptom">Symptom</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.symptom}</dd>
          <dt>
            <span id="subSpeciality">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.subSpeciality">Sub Speciality</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.subSpeciality}</dd>
          <dt>
            <span id="group">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.group">Group</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.group}</dd>
          <dt>
            <span id="forAppointment">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.forAppointment">For Appointment</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.forAppointment ? 'true' : 'false'}</dd>
          <dt>
            <span id="forPrescription">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.forPrescription">For Prescription</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.forPrescription ? 'true' : 'false'}</dd>
          <dt>
            <span id="subGroup">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.subGroup">Sub Group</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.subGroup}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.country">Country</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.country}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.sortOrder}</dd>
          <dt>
            <span id="groupOnly">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.groupOnly">Group Only</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.groupOnly ? 'true' : 'false'}</dd>
          <dt>
            <span id="vitalCode">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.vitalCode">Vital Code</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.vitalCode}</dd>
          <dt>
            <span id="config">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.config">Config</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.config}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{specialityVitalsEntity.entityId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialityVitals.parent">Parent</Translate>
          </dt>
          <dd>{specialityVitalsEntity.parent ? specialityVitalsEntity.parent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialityVitals.specialty">Specialty</Translate>
          </dt>
          <dd>{specialityVitalsEntity.specialty ? specialityVitalsEntity.specialty.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialityVitals.language">Language</Translate>
          </dt>
          <dd>{specialityVitalsEntity.language ? specialityVitalsEntity.language.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/speciality-vitals" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/speciality-vitals/${specialityVitalsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SpecialityVitalsDetail;
